var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"global-chat-active-chat-messages-container__message"},[_c('div',{staticClass:"global-chat-active-chat-messages-container__bubble"},[_c('div',{staticClass:"global-chat-active-chat-messages-container__content-text"},[_vm._v("\n      "+_vm._s(_vm.lang.get('event_strings.global-chat.empty_chat_placeholder_text'))+"\n    ")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }